import { Component, Prop, Watch } from 'vue-property-decorator';
import { DeckCategoryView } from '../DecksAndCabinsModule.types';
import { CtaItemType } from '@/components/CtaItem/CtaItem';
import CtaItem from '@/components/CtaItem/CtaItem.vue';

import ResponsiveImageRatio from '@/components/ResponsiveImageRatio/ResponsiveImageRatio.vue';
import { ImageWidths } from '@/common/interfaces/SizeBreakpoints';
import { SwiperOptions } from '@/utils/swiperUtils';
import 'swiper/dist/css/swiper.css';

import Arrow from '@/assets/icons/arrow.svg?inline';
import InputCheck from '@/components/InputCheck/InputCheck.vue';
import { mixins } from 'vue-class-component';
import SwiperMixin from '@/mixins/SwiperMixin';
import { SegmentElement } from '@/plugins/utm/SegmentElement';

@Component({
  components: { ResponsiveImageRatio, CtaItem, Arrow, InputCheck },
})
export default class DeckCategory extends mixins(SwiperMixin) {
  @Prop({ type: Object as () => DeckCategoryView, default: {} })
  readonly categoryView!: DeckCategoryView;

  @Prop({ type: Array as () => CtaItemType[], default: () => [] })
  readonly ctaItems!: CtaItemType[];

  @Prop({ type: Array as () => CtaItemType[], default: () => [] })
  readonly bookCtaItems!: CtaItemType[];

  swiperActiveIndex: number = 0;
  wasInteracted = false;

  get resetSwiper() {
    return this.categoryView;
  }

  @Watch('resetSwiper')
  resetSwiperActivate() {
    if (this.categoryView.ResetSwiper) {
      this.swiper.slideTo(0);
    }
  }

  slideNext() {
    this.swiper.slideNext();
    this.onModuleInteraction();
  }

  slidePrev() {
    this.swiper.slidePrev();
    this.onModuleInteraction();
  }

  slideTo(index: number) {
    this.swiper.slideTo(index);
    this.swiper.on('slideChangeTransitionStart', () => {
      this.swiperActiveIndex = this.swiper.activeIndex;
    });
    this.onModuleInteraction();
  }

  get paginationArray() {
    const paginationArray = [...this.category.Images];
    const paginationArrayLength = paginationArray.length;
    const newPaginationArrayLength = paginationArrayLength - 1;

    paginationArray.length = newPaginationArrayLength;

    return window.innerWidth > 600 ? paginationArray : this.category.Images;
  }

  get category() {
    return this.categoryView && this.categoryView.Category ? this.categoryView.Category : null;
  }

  get monthsOfDepartures() {
    return this.categoryView ? this.categoryView.MonthsOfDepartures : null;
  }

  get shipItinerariesLink() {
    return this.categoryView ? this.categoryView.ShipItinerariesLink : null;
  }

  get currentDate() {
    return this.categoryView ? this.categoryView.CurrentDate : null;
  }

  get currentItinerayUrl() {
    return this.$store.state.DecksAndCabinsModule.itineraryUrl;
  }

  get hasPrices() {
    return this.category.Single?.Price || this.category.Double?.Price || this.category.Triple?.Price;
  }

  imageWidths: ImageWidths = {
    def: 463,
    sizes: {
      sm: 636,
      md: 992,
      lg: 793,
      xl: 993,
    },
  };

  get swiperOption(): SwiperOptions {
    return {
      slidesPerView: 2,
      spaceBetween: 16,
      speed: 500,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: `#swiper-button-next-${this.uuid}`,
        prevEl: `#swiper-button-prev-${this.uuid}`,
      },
      pagination: {
        el: `#c-${this.uuid}-swiper-pagination`,
        clickable: true,
        dynamicBullets: true
      },
      breakpoints: {
        600: {
          slidesPerView: 1,
        },
      },
      on: {
        touchStart: () => this.onModuleInteraction(),
      },
    };
  }

  onModuleInteraction() {
    if (!this.wasInteracted) {
      const module = this.$el.closest('*[contentlinkid]') as HTMLElement;
      this.wasInteracted = true;
      SegmentElement.sendEvent('moduleInteraction', {
        component_name: 'DeckCategory',
        module_type_id: module.getAttribute('data-segmentid'),
        module_type_name: module.getAttribute('type'),
        position: this.swiper.activeIndex + 1,
        interaction_type: 'carousel',
      })
    }
  }

  updated() {
    this.swiper.on('slideChangeTransitionStart', () => this.swiperActiveIndex = this.swiper.activeIndex);
  }
}
